const CALL_REQUEST_SET_LAHI_SESSION_ID = 'callRequestSetLahiSessionId';
const CALL_REQUEST_SET_URL_PREFIX = 'callRequestSetUrlPrefix';
const CALL_REQUEST_SET_VHK_ID = 'callRequestSetVhkId';

export const callRequestState = {
	lahiSessionId: null,
	urlPrefix: '',
	vhkId: ''
};

export const callRequestActions = {
	setLahiSessionId({ commit }, lahiSessionId) {
		commit(CALL_REQUEST_SET_LAHI_SESSION_ID, lahiSessionId);
	},
	setUrlPrefix({ commit }, urlPrefix) {
		commit(CALL_REQUEST_SET_URL_PREFIX, urlPrefix);
	},
	setVhkId({ commit }, vhkId) {
		commit(CALL_REQUEST_SET_VHK_ID, vhkId);
	}
};

export const callRequestMutations = {
	[CALL_REQUEST_SET_LAHI_SESSION_ID](state, lahiSessionId) {
		state.lahiSessionId = lahiSessionId;
	},
	[CALL_REQUEST_SET_URL_PREFIX](state, urlPrefix) {
		state.urlPrefix = urlPrefix;
	},
	[CALL_REQUEST_SET_VHK_ID](state, vhkId) {
		state.vhkId = vhkId;
	}
};
